export const SEND_CODE_INITIAL_STATE = {
  message: '',
  hasError: false,
  canSendCode: false,
  isLoading: false,
}
